"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUrlParts = getUrlParts;
exports.getMeetingLinkSlug = getMeetingLinkSlug;
exports.formatUserName = formatUserName;
exports.validateEmail = validateEmail;
exports.validateUrl = validateUrl;
exports.validateLink = validateLink;
exports.getRelAttrTrackingValues = exports.comparePageURLs = exports.getAlphabeticalSortPrioritizingUser = exports.alphabeticalSort = exports.isMeetingLink = exports.getSetupMeetingLinkUrl = exports.trimQueryString = exports.trimAnchorSuffix = exports.trimProtocol = void 0;

var _enviro = _interopRequireDefault(require("enviro"));

var _PortalIdParser = _interopRequireDefault(require("PortalIdParser"));

var _iterables = require("./iterables");

var _UrlParts = _interopRequireDefault(require("PatternValidationJS/regex/parts/UrlParts"));

var _link = require("../constants/link");

var emailQueryWord = '([^\\s?=&]+)';
var emailQueryParamater = emailQueryWord + "=" + emailQueryWord;
var emailQueryExpression = "\\?" + emailQueryParamater + "(&" + emailQueryParamater + ")*";
var EMAIL_ADDRESS_REGEX = new RegExp("^(.+)@" + _UrlParts.default.domain + "(" + emailQueryExpression + ")?$");
var ANCHOR_REGEX = new RegExp(/^#\S/);
var TEL_REGEX = new RegExp(/^tel:\S/);
var RELATIVE_URL_REGEX = new RegExp(/^\/\S/); // Exact copy of UrlRegexFactory from PatternValidationJS, but with required protocol

var URL_REGEX_WITH_REQUIRED_PROTOCOL_REGEX = new RegExp("^" + _UrlParts.default.protocol + _UrlParts.default.domain + "(" + _UrlParts.default.path + "(" + _UrlParts.default.file + ")?)?" + _UrlParts.default.search + "?$", 'i');
var HUBL_REGEX = new RegExp(/^(\S*{{.+}}\S*)+$/);

function trimLeadingSlash(string) {
  return string.split('/').splice(1).join('/');
}

var trimProtocol = function trimProtocol(url) {
  return url.split('://')[1];
};

exports.trimProtocol = trimProtocol;

var trimAnchorSuffix = function trimAnchorSuffix(url) {
  return url.split('#')[0];
};

exports.trimAnchorSuffix = trimAnchorSuffix;

var trimQueryString = function trimQueryString(url) {
  return url.split('?')[0];
};

exports.trimQueryString = trimQueryString;
var cleanPageUrl = (0, _iterables.compose)(trimProtocol, trimAnchorSuffix, trimQueryString);

function getUrlParts(href) {
  var anchor = document.createElement('a');
  anchor.href = href;
  return {
    domain: anchor.hostname,
    protocol: anchor.protocol,
    slug: trimLeadingSlash(anchor.pathname)
  };
}

function getMeetingLinkSlug(href) {
  var _getUrlParts = getUrlParts(href),
      slug = _getUrlParts.slug;

  var match = /^meetings\/(.+)/.exec(slug);

  if (match && match[1]) {
    slug = encodeURIComponent(match[1]);
  }

  return slug;
}

function formatUserName(user) {
  var firstName = user.firstName,
      lastName = user.lastName,
      email = user.email;

  if (firstName || lastName) {
    return ((firstName || '') + " " + (lastName || '')).trim();
  }

  return email;
}

function validateEmail(link) {
  var email = link.replace(/^mailto:/, '');
  return EMAIL_ADDRESS_REGEX.test(email) || HUBL_REGEX.test(email);
}

function validateUrl(link) {
  return ANCHOR_REGEX.test(link) || TEL_REGEX.test(link) || RELATIVE_URL_REGEX.test(link) || URL_REGEX_WITH_REQUIRED_PROTOCOL_REGEX.test(link) || HUBL_REGEX.test(link);
}

function validateLink(linkType, link) {
  switch (linkType) {
    case _link.LinkTypes.EMAIL:
      return validateEmail(link);

    case _link.LinkTypes.URL:
      return validateUrl(link);

    default:
      return true;
  }
}

var getSetupMeetingLinkUrl = function getSetupMeetingLinkUrl() {
  return "https://app.hubspot" + (_enviro.default.isQa() ? 'qa' : '') + ".com/settings/" + _PortalIdParser.default.get() + "/sales/meetings/integration";
};

exports.getSetupMeetingLinkUrl = getSetupMeetingLinkUrl;

var isMeetingLink = function isMeetingLink(href) {
  var _getUrlParts2 = getUrlParts(href),
      slug = _getUrlParts2.slug,
      domain = _getUrlParts2.domain;

  return slug.startsWith('meetings/') || domain.startsWith('meetings.hubspot');
};

exports.isMeetingLink = isMeetingLink;

var alphabeticalSort = function alphabeticalSort(a, b) {
  if (a.text < b.text) return -1;else if (a.text > b.text) return 1;else return 0;
};

exports.alphabeticalSort = alphabeticalSort;

var getAlphabeticalSortPrioritizingUser = function getAlphabeticalSortPrioritizingUser(userId) {
  return function (a, b) {
    if (a.userId === userId) return -1;else if (b.userId === userId) return 1;else return alphabeticalSort(a, b);
  };
};

exports.getAlphabeticalSortPrioritizingUser = getAlphabeticalSortPrioritizingUser;

var comparePageURLs = function comparePageURLs(domainA, domainB) {
  return cleanPageUrl(domainA) === cleanPageUrl(domainB);
};

exports.comparePageURLs = comparePageURLs;

var getRelAttrTrackingValues = function getRelAttrTrackingValues() {
  var relAttr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var trackingValues = relAttr.reduce(function (acc, value) {
    if (value === _link.LinkRelDefault) return acc; // `noopener` is always true so no need to track

    acc[value] = true;
    return acc;
  }, {});
  return trackingValues;
};

exports.getRelAttrTrackingValues = getRelAttrTrackingValues;